import { AnyFieldMeta, Updater } from '@tanstack/form-core'

type FieldStateLike = {
    meta: Omit<AnyFieldMeta, 'errorMap'>
}

export interface FieldApiLike<TData = unknown> {
    state: FieldStateLike
    handleBlur: () => void
    handleChange: (updater: Updater<TData>) => void
}

export type FormFieldMetaPropsOptions = {
    /**
     * If true, the error will be shown even if the field has not been touched.
     * Normally we only want to show errors if the field has been touched.
     * Can be useful if the validation of the field is dependent on other fields.
     */
    errorIgnoreTouched?: boolean
}

export function createFormFieldMetaProps<TData>(fieldApi: FieldApiLike<TData>, options: FormFieldMetaPropsOptions = {}) {
    const isError = !fieldApi.state.meta.isValid
    const showError = options.errorIgnoreTouched ? isError : fieldApi.state.meta.isTouched && isError
    const firstError = fieldApi.state.meta.errors[0]?.message
    return {
        error: showError,
        errorText: showError ? firstError : undefined,
    }
}
